import { render, staticRenderFns } from "./ElectronicsDetail.vue?vue&type=template&id=3d4dc04a&scoped=true&"
import script from "./ElectronicsDetail.vue?vue&type=script&lang=js&"
export * from "./ElectronicsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicsDetail.vue?vue&type=style&index=0&id=3d4dc04a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4dc04a",
  null
  
)

export default component.exports